import { Middleware } from "@reduxjs/toolkit";

export const brands: Middleware = api => next => action => {
  const userBrands = api.getState().user.brands;
  if(!userBrands) {
  }
  return next(action);
};